/* @flow */
import * as React from 'react';

const Tiktok = () => (
  <svg
    data-name="Layer 1"
    id="Layer_1"
    viewBox="0 0 512 512"
    width={20}
    height={20}
    xmlns="http://www.w3.org/2000/svg">
    <path d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM385.62,232.382c-27.184,0-53.634-8.822-74-23.75l-.162,101.5a92.457,92.457,0,1,1-80.178-91.721v49.845a43.657,43.657,0,1,0,31.288,41.876V109.333h51.275a71.773,71.773,0,0,0,71.774,71.773Z" />
  </svg>
);

export default Tiktok;



// WEBPACK FOOTER //
// ./src/assets/images/icons/tiktok.js